import { useEffect, useState } from 'react';
import { FicheType } from '../../FicheType/FicheType';
import { MoreInfo } from "../../MoreInfo/MoreInfo";
import './FicheAdres.scss';

export const FicheAdres = (props) => {
    const [bodyItems, setBodyItems] = useState([]);

    //Processs body items
    useEffect(() => {
        let items = props.processFicheItems(props.data.body.items);
        setBodyItems(items);
    }, [JSON.stringify(props.data.body.items)]);

    return(
        <div 
            className={`c-fiche c-fiche-address ${props.data?.link ? "u-has-detail" : ""}`}
            onClick={() => {
                if(props.data?.link){
                    window.open(props.data.link, "_blank");
                }
            }}
            data-aos="fade-up"
        >
        <div>
            <FicheType type={props.data.type}/>
            <header className="c-fiche__header">
                <h2 className='title'>
                    {props.data.title}
                </h2>
            </header>
            <div className="c-fiche__body">
                <ul>
                    {bodyItems}
                </ul>
            </div>
            {props.data.link &&
                <MoreInfo
                    data={{hasDetail: true}}
                    url={props.data.link}
                    cta={props.dictionary.viewFile}
                />
                }
        </div>
    </div>
    );
}